import React from 'react';
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";
import {submitFeedback} from "../../../MiddlePopup/Settings/SettingsContent/Feedback/submitFeedback.ts";
import {openSubscribe} from "../../../../Utils/misc/openLink.ts";

interface UpgradeProps {}

const Upgrade: React.FC<UpgradeProps> = ({ }) => {
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;

    const handleUpgradeClick = async (event: React.MouseEvent) => {
        submitFeedback(user, `User clicked upgrade button in in ${environment}`);
        openSubscribe(event, environment, vscode);
    };

    return (
        <button
            onClick={handleUpgradeClick}
            className="px-2.5 py-1 rounded-lg text-cyan-600 hover:text-cyan-500 bg-neutral-950 dark:bg-neutral-800 hover:bg-neutral-300 dark:hover:bg-neutral-700 bg-opacity-10 hover:bg-opacity-20">
            {"✨Upgrade✨"}
        </button>
    );
};

export default Upgrade;
